/**
 * Manuel taksit tablosu — tema ayarlarındaki oranlardan ürün fiyatına göre tablo üretir.
 * Plan formatı: "KartAdı|2:1,3:1,6:1.05" kartlar @@ ile ayrılır; çarpan toplam tutar çarpanıdır (1 = peşin fiyatına).
 */
(function () {
  if (customElements.get('manual-installment-table')) return;

  customElements.define(
    'manual-installment-table',
    class ManualInstallmentTable extends HTMLElement {
      connectedCallback() {
        this.#render();
        document.addEventListener('variant:update', this.#onVariantUpdate);
      }

      disconnectedCallback() {
        document.removeEventListener('variant:update', this.#onVariantUpdate);
      }

      #onVariantUpdate = (event) => {
        const productId = this.dataset.productId;
        if (!productId || String(event.detail?.data?.productId) !== String(productId)) return;
        const price = event.detail?.resource?.price;
        if (price == null) return;
        this.dataset.price = String(price / 100);
        this.#render();
      };

      #parsePlans() {
        const raw = this.dataset.plans || '';
        if (!raw) return [];

        return raw.split('@@').map((entry) => {
          const segments = entry.split('|');
          const name = segments[0]?.trim();
          let ratesRaw = '';
          let inlineLogo = '';

          if (segments.length >= 3) {
            inlineLogo = segments[2]?.trim() || '';
            ratesRaw = segments[1]?.trim() || '';
          } else {
            ratesRaw = segments[1]?.trim() || '';
          }

          if (!name || !ratesRaw) return null;

          const rates = ratesRaw.split(',').map((part) => {
            const [countStr, multiplierStr] = part.split(':');
            const count = Number(countStr?.trim());
            const multiplier = Number((multiplierStr || '1').trim().replace(',', '.'));
            if (!count || count < 1 || Number.isNaN(multiplier)) return null;
            return { count, multiplier };
          }).filter(Boolean);

          if (!rates.length) return null;
          return { name, rates, inlineLogo };
        }).filter(Boolean);
      }

      #parseLogos() {
        const raw = this.dataset.logos || '';
        if (!raw) return [];
        return raw.split('||');
      }

      #render() {
        const root = this.querySelector('.manual-installment-table__root');
        const basePrice = Number(this.dataset.price);
        if (!root || !basePrice || basePrice <= 0) return;

        const plans = this.#parsePlans();
        const logos = this.#parseLogos();
        const featured = Number(this.dataset.featuredInstallment) || 3;

        if (!plans.length) {
          root.innerHTML =
            '<p class="manual-installment-table__error">Taksit planı tanımlanmamış. Tema düzenleyicisinden manuel taksit ayarlarını kontrol edin.</p>';
          return;
        }

        let html = '';

        plans.forEach((plan, index) => {
          const logoUrl = plan.inlineLogo || logos[index] || '';
          const logoHtml = logoUrl
            ? `<img src="${logoUrl}" alt="${plan.name}" loading="lazy" onerror="this.style.display='none'">`
            : `<span class="manual-installment-table__bank-name">${plan.name}</span>`;

          html += '<div class="taksit-tablosu-wrapper">';
          html += `<div class="taksit-logo">${logoHtml}</div>`;
          html += '<div class="taksit-baslik">';
          html += '<div class="taksit-tutari-text">Taksit Tutarı</div>';
          html += '<div class="taksit-tutari-text">Toplam Tutar</div>';
          html += '</div>';

          plan.rates.forEach((rate) => {
            const totalPrice = basePrice * rate.multiplier;
            const installmentPrice = totalPrice / rate.count;
            const bold = rate.count === featured ? ' taksit-tutari-bold' : '';

            html += `<div class="taksit-tutar-wrapper${bold}">`;
            html += `<div class="taksit-tutari">${rate.count} x ${this.#formatMoney(installmentPrice)}</div>`;
            html += `<div class="taksit-tutari">${this.#formatMoney(totalPrice)}</div>`;
            html += '</div>';
          });

          html += '</div>';
        });

        root.innerHTML = html;
      }

      #formatMoney(amount) {
        const value = Number(amount);
        if (Number.isNaN(value)) return '';
        const formatted = value.toLocaleString('tr-TR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        const template = this.dataset.moneyFormat || '{{amount}} TL';
        if (template.includes('{{')) {
          return template.replace(/\{\{\s*amount\s*\}\}/gi, formatted);
        }
        return formatted + ' TL';
      }
    }
  );
})();
